var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.983 16a3.213 3.213 0 00-1.085-2.4L15.993.481a1.92 1.92 0 00-2.533 2.882l11.516 10.133a.334.334 0 01-.22.583H1.937a1.92 1.92 0 000 3.84h22.815a.334.334 0 01.22.584L13.456 28.636a1.92 1.92 0 102.533 2.881l14.908-13.119a3.213 3.213 0 001.087-2.4z"
  })));
}
export default SvgArrowRight;